import React from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { parse, differenceInDays } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { stateToTzMap } from '@ourbranch/state-to-tz-map';

import { Label } from 'core/components/label';
import { Button } from 'core/components/button';
import { useStore } from 'core/store/store.mobx';
import useSession from 'core/hooks/use-session';
import useStyles from '../footer.styles';

const OfferExpired = observer(() => {
  const {
    offer: store,
    quote: quoteStore,
    account: { sendEventAsMember }
  } = useStore();
  const { isAgency, user } = useSession();
  const classes = useStyles();
  const router = useHistory();

  const { offer, loading } = store;
  const { state, quote, webUserId } = offer;

  const sendToQuoteAndPrefill = async () => {
    // get daysOld
    const today = utcToZonedTime(new Date(), stateToTzMap[state]);
    const rateControlDate = utcToZonedTime(
      parse(quote?.global?.rateControlDate, 'yyyy-MM-dd', new Date()).setHours(today.getHours()),
      stateToTzMap[state]
    );
    const daysOld = differenceInDays(today, rateControlDate);

    await sendEventAsMember({
      eventName: 'Staff Requote - Applicant',
      userId: webUserId,
      properties: JSON.stringify({
        affinityCode: user.affinityCode,
        daysOld,
        isAgency
      })
    });
    quoteStore.setPrefillData(offer);
    router.push('/quote');
  };

  return (
    <>
      <Label type="whiteMedium">This offer has expired. Please requote from scratch.</Label>
      <Button
        onClick={sendToQuoteAndPrefill}
        disabled={loading}
        loading={loading}
        variant="contained"
        color="primary"
        className={classes.btn}
      >
        <Label className={classes.btnLabel}>Requote </Label>
      </Button>
    </>
  );
});

export default OfferExpired;
